//import styles
import '@fancyapps/ui/dist/fancybox/fancybox.css';

//import libs
import ClipboardManager from './plugins/clipboardManager/index'; // Импорт нового класса

import { Modals } from "./modals/index"

// import utils
import { isTouchEnabled } from "./utils/isTouchEnabled"
import { isMobileDevice } from "./utils/isMobileDevice"
import { parseJSON } from "./utils/parseJSON"
import { wait } from "./utils/wait"
import { debounce } from "./utils/debounce";
import { setCSSVar } from "./utils/setCSSVar";
import { onDOMContentLoaded } from "./utils/onDOMContentLoaded";
import { getScrollBarWidth } from "./utils/getScrollBarWidth";

// load modules
import { HeaderResizeObserver} from "./plugins/header";
import { TabsModel } from "./plugins/tabs/tabs";
import { RangeSliderCollection } from "./plugins/rangeSlider/randgeSlider"
import { ApiClient } from "./apiClient/apiClient";
import { ElementInserter } from "./utils/elementInsert";
import { FileAttachCollection } from "./fileAttach/index"
import Forms from "./forms/index"
import Dispatcher from "./generic/dispatcher";
import Observer from "./generic/observer";
import { DisclaimerCookie } from "./plugins/disclaimer";


window.App = {
    scrollableBody: "body",
    isDebug: window.location.port.length > 0 || window.location.host === "localhost" || (window.location.search.indexOf("debug") > -1) || window.location.pathname.indexOf("/build/") > -1,
    isTest: process.env.NODE_ENV === "test",
    stateClasses: {
        domReady: "isDomReady",
        pageLoaded: "isPageLoaded",
        touchscreen: "isTouchscreen",
        mobileDevice: "isMobileDevice"
    },
    ...parseJSON(document.body.getAttribute("data-js-app-globals")),
    utils: { // utils functions
        setVhVar: () => setCSSVar(document.documentElement, "vh", `${ (window.innerHeight * 0.01).toFixed(3) }px`),
        checkMobile: () => (isMobileDevice()) ? document.documentElement.classList.add(App.stateClasses.mobileDevice) : document.documentElement.classList.remove(App.stateClasses.mobileDevice),
        checkTouch: () => (isTouchEnabled()) ? document.documentElement.classList.add(App.stateClasses.touchscreen) : document.documentElement.classList.remove(App.stateClasses.touchscreen),
        checkSpecificBrowser: () => {
            let browserClass = "";
            switch (true) {
                case !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/)):
                    browserClass = "ie11";
                    break;
                case !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/):
                    browserClass = "safari";
                    break;
                case /Edge/.test(navigator.userAgent):
                    browserClass = "edge";
                    break;
                default:
                    break;
            }
            if (browserClass) {
                document.documentElement.classList.add(browserClass);
            }
        },
        getScrollBarWidth: () => setCSSVar(document.documentElement, "scrollBarWidth", `${ getScrollBarWidth() }px`)
    }
};




const bindEvents = () => {
    const handleDOMReady = () => {
        // run utils
        Object.values(App.utils).forEach(fn => typeof fn === "function" && fn());

        // standalone components
        window.App.ApiClient = new ApiClient()
        new Forms()
        new HeaderResizeObserver()
        new Modals()
        new DisclaimerCookie()
        new TabsModel()

        // clipboard js
        new ClipboardManager();
        new ElementInserter("от", "#wpfMinPrice", "before-wpf-min-price").setParentRelative().addDivBeforeElement()
        new ElementInserter("до", "#wpfMaxPrice", "after-wpf-min-price").setParentRelative().addDivBeforeElement()

        // app components
        // App.ScrollEffects = new ScrollEffects();
        // App.GoogleCaptchaCollection = new GoogleCaptchaCollection();
        // App.SlidersCollection = new SlidersCollection();
        App.RangeSliderCollection = new RangeSliderCollection();

        // subscribe on content updates && run mutation observer
        App.Dispatcher = new Dispatcher();
        App.Observer = new Observer();
        
        App.FileAttachCollection = new FileAttachCollection();

        // prevent transition flicker
        wait(100).then(() => document.documentElement.classList.add(App.stateClasses.domReady));
    }
    const debouncedResizeHandler = debounce(App.utils.setVhVar);
    const handleResize = () => {
        debouncedResizeHandler();
        App.utils.checkTouch();
        App.utils.checkMobile();
        App.utils.getScrollBarWidth();
    }
    const handleWindowLoad = () => document.documentElement.classList.add(App.stateClasses.pageLoaded)
    onDOMContentLoaded(() => handleDOMReady());
    window.addEventListener("resize", () => handleResize());
    window.addEventListener("load", () => handleWindowLoad());
};

bindEvents();